import React from 'react';
import SectionHeader, { HeaderControl } from '../common/SectionHeader';
import { faPrint, faFileClipboard, faCopy } from '@fortawesome/free-solid-svg-icons';

interface PulseContentHeaderProps {
  title: string;
  isLoading: boolean;
  onCopyRawData: () => void;
  onCopyView: () => void;
  onPrintView: () => void;
}

const PulseContentHeader: React.FC<PulseContentHeaderProps> = ({
  title,
  isLoading,
  onCopyRawData,
  onCopyView,
  onPrintView,
}) => {
  const contentControls: HeaderControl[] = [
    { id: 'content-copy-data', icon: faFileClipboard, tooltip: 'Copy Raw Data', onClick: onCopyRawData },
    // { id: 'content-copy-formatted', icon: faCopy, tooltip: 'Copy View', onClick: onCopyView },
    { id: 'content-print', icon: faPrint, tooltip: 'Print View', onClick: onPrintView },
  ];

  return <SectionHeader title={title} controls={contentControls} isLoading={isLoading} />;
};

export default PulseContentHeader;